import { render, staticRenderFns } from "./TagsManager.vue?vue&type=template&id=006cb86c&scoped=true&"
import script from "./TagsManager.vue?vue&type=script&lang=js&"
export * from "./TagsManager.vue?vue&type=script&lang=js&"
import style0 from "./TagsManager.vue?vue&type=style&index=0&id=006cb86c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006cb86c",
  null
  
)

export default component.exports